import { createFileRoute } from "@tanstack/react-router";
import { TbChartBar, TbChartPie } from "react-icons/tb";

import { Link as AppLink } from "@/components/link";
import { APP_ROUTES_FULL, APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.TESTING_INDEX)({
    component: TestingIndexPage,
});

const EXPERIMENTS = [
    {
        id: "kpis-report",
        title: "KPIs report",
        description:
            "Weekly KPI table for all agents by team. Shows all / bruttos / netto per day and week average per person and per team.",
        to: APP_ROUTES_TO.TESTING_KPIS_REPORT,
        icon: TbChartBar,
    },
    {
        id: "incident-analytics",
        title: "Incident analytics",
        description:
            "Monthly and weekly incident volume charts with status filter, plus a top-types bar chart and full list breakdown by incident type.",
        to: APP_ROUTES_TO.TESTING_INCIDENT_ANALYTICS,
        icon: TbChartPie,
    },
] as const;

function TestingIndexPage() {
    return (
        <div className="flex flex-col gap-4">
            <div>
                <h1 className="text-2xl font-semibold">Testing</h1>
                <p className="text-muted-foreground">
                    Internal testing area. Use this page to experiment with new components and flows in development.
                </p>
            </div>

            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {EXPERIMENTS.map((exp) => {
                    const Icon = exp.icon;
                    return (
                        <AppLink
                            key={exp.id}
                            to={exp.to}
                            className="flex flex-col gap-3 rounded-lg border bg-card p-4 text-left shadow-sm transition-colors hover:bg-accent/50 hover:shadow-md"
                        >
                            <div className="flex items-center gap-3">
                                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary">
                                    <Icon className="h-5 w-5" />
                                </div>
                                <h2 className="font-semibold">{exp.title}</h2>
                            </div>
                            <p className="text-sm text-muted-foreground">{exp.description}</p>
                        </AppLink>
                    );
                })}
            </div>
        </div>
    );
}
